<template>
  <div id="app" class="container">
    <nav-bar :currentPageName="currentPageName"></nav-bar>
    <router-view @PageNameChanged="updatePageName" />
  </div>
</template>

<script>
import {mapState} from 'vuex';

import store from './store';
import router from './router';
import NavBar from './components/NavBar.vue';

export default {
  name: 'App',
  router,
  store,
  data: function() {
    return {
      otherPageUrl: '#',
      otherPageName: '',
      store: this.$store,
      currentPageName: '',
    };
  },
  components: { NavBar },
  methods: {
    updatePageName(name) {
      this.pageName = name;
      this.$store.commit('currentPageName', name);
    },
  },

  computed: mapState(['currentPageName'])
};
</script>

<style>
.chat {
  list-style: none;
  margin: 0;
  padding: 0;
}

.chat li {
  margin-bottom: 10px;
  padding-bottom: 5px;
  border-bottom: 1px dotted #b3a9a9;
}

.chat li.left .chat-body {
  margin-left: 60px;
  text-align: left;
}

.chat li.right .chat-body {
  margin-right: 60px;
}

.chat li .chat-body p {
  margin: 0;
  color: #777777;
}

.panel .slidedown .glyphicon,
.chat .glyphicon {
  margin-right: 5px;
}

.panel-body {
  overflow-y: scroll;
  height: 250px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

::-webkit-scrollbar {
  width: 12px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #555;
}

.float-right {
  float: right;
}
</style>
